import { Footer } from "./Footer";
import { StickyTableBodyMultilineData as MultilineData } from "./Body/StickyTableBodyMultilineData";
import { StickyTableContainer as StickyTable } from "./StickyTableContainer";
import { StickyTableData } from "./Body/StickyTableData";
import { StickyTableHeader } from "./StickyTableHeader";
import { StickyTableHeaderBody } from "./StickyTableHeaderBody";
import { StickyTableSidebar } from "./StickyTableSidebar";
import { MultiRowContainer } from "./MultilineRow/MultiRowContainer";
import { MultilinePagerContainer } from "./MultilineRow/MultilinePager/MultilinePagerContainer";

// @ts-ignore Тут и ниже у меня никак не типизируется
StickyTable.MultilineRow = { Sidebar: MultiRowContainer, Data: MultilineData, Pager: MultilinePagerContainer };
// @ts-ignore
StickyTable.Sidebar = StickyTableSidebar;
// @ts-ignore
StickyTable.Header = StickyTableHeader;
// @ts-ignore
StickyTable.Header.Body = StickyTableHeaderBody;
// @ts-ignore
StickyTable.Data = StickyTableData;
// @ts-ignore
StickyTable.Footer = Footer;

export { StickyTable };
